export type RealtimeVoiceDestination = {
  scope?: 'source' | 'destination';
  dispatchId?: string;
  targetOrgThreadId?: string;
  targetHref?: string;
  targetTitle?: string;
};

/** Only backend-confirmed dispatches can establish conversational destination. */
export function updateRealtimeVoiceDestination(
  current: RealtimeVoiceDestination | null,
  incoming: Partial<RealtimeVoiceDestination> & { status?: string },
  origin: 'send' | 'event'
): RealtimeVoiceDestination | null {
  if (
    !incoming.dispatchId ||
    (origin === 'send' &&
      incoming.status !== 'sent' &&
      incoming.status !== 'queued')
  )
    return current;
  // A late result from an earlier request must not redirect a newer follow-up.
  if (
    origin === 'event' &&
    current &&
    (current.scope === 'source' || current.dispatchId !== incoming.dispatchId)
  )
    return current;
  return {
    ...(current?.dispatchId === incoming.dispatchId ? current : {}),
    dispatchId: incoming.dispatchId,
    ...(incoming.targetOrgThreadId
      ? { targetOrgThreadId: incoming.targetOrgThreadId }
      : {}),
    ...(incoming.targetHref ? { targetHref: incoming.targetHref } : {}),
    ...(incoming.targetTitle ? { targetTitle: incoming.targetTitle } : {}),
  };
}

export type RealtimeVoiceQuestionFocus = {
  scope: 'source' | 'destination';
  dispatchId?: string;
  toolCallId?: string;
  questionRevision?: string;
};

export function resolveRealtimeVoiceDispatchId(
  input: { scope?: 'source' | 'destination'; dispatchId?: string },
  destination: RealtimeVoiceDestination | null,
  question?: RealtimeVoiceQuestionFocus | null
): string | undefined {
  if (input.scope === 'source') return undefined;
  if (input.dispatchId?.startsWith('ot_')) return undefined;
  // Thread routes (ot_...) identify source threads, not threadDispatches.
  // Never pass model-supplied route ids into the Convex dispatch validator.
  if (input.dispatchId && !input.dispatchId.startsWith('ot_'))
    return input.dispatchId;
  if (input.scope !== 'destination' && question)
    return question.scope === 'source' ? undefined : question.dispatchId;
  return destination?.dispatchId;
}
